import Paper from "@components/Paper/Paper";
import PaperItem from "@components/Paper/PaperItem";
import type { PortService } from "@services/port-services/types";
import { t } from "i18next";

const TEST_ID_BASE = "port-services-preview";
const wrapperStyleClass = "border-b border-[#F1F2F4] pb-3";
const wrapperLastStyleClass = "pb-0";
const transStyleClass = "font-normal text-[#646A77]";

interface WasteDisposalGarbageProps {
  langBase: string;
  portServiceDetails: PortService;
}

const WasteDisposalGarbage: React.FC<WasteDisposalGarbageProps> = ({
  langBase,
  portServiceDetails,
}) => {
  return (
    <Paper variant="outlined">
      <p className="font-bold">{t(`${langBase}.service-details`)}</p>
      <div className="grid grid-cols-2">
        <div>
          <PaperItem
            testId={`${TEST_ID_BASE}-service-category`}
            translate={t(`${langBase}.service-category`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.serviceCategory || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-service-type`}
            translate={t(`${langBase}.service-type`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.serviceType || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-service-subtype`}
            translate={t(`${langBase}.service-subtype`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.serviceSubType || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-garbage-category`}
            translate={t(`${langBase}.garbage-category`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.garbageCategory || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-location`}
            translate={t(`${langBase}.location`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.location || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-berth-anchorage-area-location`}
            translate={t(`${langBase}.berth-anchorage-area-location`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.berthOrAnchorageCode || "-"}
          />
        </div>
        <div>
          <PaperItem
            testId={`${TEST_ID_BASE}-quantity`}
            translate={t(`${langBase}.quantity`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.quantity || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-unit-of-measurement`}
            translate={t(`${langBase}.unit-of-measurement`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.unitOfMeasurement || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-number-of-skips`}
            translate={t(`${langBase}.number-of-skips`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.numberOfSkips || "-"}
          />
          <PaperItem
            testId={`${TEST_ID_BASE}-additional-number-of-skips`}
            translate={t(`${langBase}.additional-number-of-skips`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperStyleClass}
            text={portServiceDetails.additionalNumberOfSkips ?? "-"}
          />
        </div>
        <div className="col-span-2">
          <PaperItem
            testId={`${TEST_ID_BASE}-remarks`}
            translate={t(`${langBase}.remarks`)}
            textStyles="font-medium"
            tranStyle={transStyleClass}
            wrapperStyle={wrapperLastStyleClass}
            labelClassName="w-1/4"
            valueClassName="w-3/4"
            text={portServiceDetails.remarks || "-"}
          />
        </div>
      </div>
    </Paper>
  );
};

export default WasteDisposalGarbage;
